// extracted by mini-css-extract-plugin
export default {"item":"TransactionCost_item__k+ewP","label":"TransactionCost_label__GcMCK","value":"TransactionCost_value__8Yd9d","cost":"TransactionCost_cost__BIVfd"};